/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/pipeline_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { PipelineServiceCreateStageTaskBody } from '../models'
// @ts-ignore
import { PipelineServiceUpdatePipelineStageBody } from '../models'
// @ts-ignore
import { PipelineServiceUpdateStageTaskBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1CreatePipelineStageRequest } from '../models'
// @ts-ignore
import { V1GetPipelineConstructorResponse } from '../models'
// @ts-ignore
import { V1ListPipelineStagesResponse } from '../models'
// @ts-ignore
import { V1ListStageTasksResponse } from '../models'
// @ts-ignore
import { V1PipelineStageResponse } from '../models'
// @ts-ignore
import { V1ReorderPipelineStagesRequest } from '../models'
// @ts-ignore
import { V1StageTaskTemplateResponse } from '../models'
/**
 * PipelineServiceApi - axios parameter creator
 * @export
 */
export const PipelineServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary CreatePipelineStage — создать этап. name вводится в ОДНОМ поле (локаль автора), бэкенд автопереводит на 3 локали через translator. Гейт = pipeline:create.
     * @param {V1CreatePipelineStageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreatePipelineStage: async (
      body: V1CreatePipelineStageRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceCreatePipelineStage', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateStageTask — добавить шаблон задачи (title автопереводится). Гейт = pipeline:update.
     * @param {string} stageId
     * @param {PipelineServiceCreateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreateStageTask: async (
      stageId: string,
      body: PipelineServiceCreateStageTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stageId' is not null or undefined
      assertParamExists('pipelineServiceCreateStageTask', 'stageId', stageId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceCreateStageTask', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages/{stageId}/tasks`.replace(
        `{${'stageId'}}`,
        encodeURIComponent(String(stageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeletePipelineStage — удалить этап (soft-delete). Запрещено при активных сделках, если не задан reassign_to_stage_id; системные этапы не удаляются. Гейт = pipeline:delete.
     * @param {string} id
     * @param {string} [reassignToStageId] Перенести сделки удаляемого этапа на этот этап (опционально). Без него удаление этапа с активными сделками запрещено.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeletePipelineStage: async (
      id: string,
      reassignToStageId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceDeletePipelineStage', 'id', id)
      const localVarPath = `/api/v1/deals/pipeline/stages/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (reassignToStageId !== undefined) {
        localVarQueryParameter['reassignToStageId'] = reassignToStageId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteStageTask — удалить шаблон задачи (soft-delete). Гейт = pipeline:update.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeleteStageTask: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceDeleteStageTask', 'id', id)
      const localVarPath = `/api/v1/deals/pipeline/stage-tasks/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetPipelineConstructor — конфигурация воронки со ВСЕМИ локалями имён/заголовков (для экрана конструктора). Гейт = pipeline:update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceGetPipelineConstructor: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/pipeline/constructor`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListPipelineStages — этапы воронки с локализованными именами (по user-locale, COALESCE→ru) для канбана и конструктора. Гейт = pipeline:read (ADMIN/HOS/CEO/MANAGER/AGENT).
     * @param {boolean} [includeTaskTemplates] Включить шаблоны задач в каждый этап (для конструктора). По умолчанию false (канбан).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListPipelineStages: async (
      includeTaskTemplates?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/pipeline/stages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeTaskTemplates !== undefined) {
        localVarQueryParameter['includeTaskTemplates'] = includeTaskTemplates
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListStageTasks — шаблоны задач этапа с локализованным заголовком (pipeline:read).
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListStageTasks: async (
      stageId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stageId' is not null or undefined
      assertParamExists('pipelineServiceListStageTasks', 'stageId', stageId)
      const localVarPath = `/api/v1/deals/pipeline/stages/{stageId}/tasks`.replace(
        `{${'stageId'}}`,
        encodeURIComponent(String(stageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ReorderPipelineStages — переупорядочить этапы (полный список id в новом порядке). Гейт = pipeline:update.
     * @param {V1ReorderPipelineStagesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceReorderPipelineStages: async (
      body: V1ReorderPipelineStagesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceReorderPipelineStages', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages:reorder`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdatePipelineStage — изменить этап (имя/цвет/тип/WIP). Имя — ручной оверрайд локали автора + автоперевод недостающих. Гейт = pipeline:update.
     * @param {string} id
     * @param {PipelineServiceUpdatePipelineStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdatePipelineStage: async (
      id: string,
      body: PipelineServiceUpdatePipelineStageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceUpdatePipelineStage', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceUpdatePipelineStage', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateStageTask — изменить шаблон задачи. Гейт = pipeline:update.
     * @param {string} id
     * @param {PipelineServiceUpdateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdateStageTask: async (
      id: string,
      body: PipelineServiceUpdateStageTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceUpdateStageTask', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceUpdateStageTask', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stage-tasks/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PipelineServiceApi - functional programming interface
 * @export
 */
export const PipelineServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PipelineServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary CreatePipelineStage — создать этап. name вводится в ОДНОМ поле (локаль автора), бэкенд автопереводит на 3 локали через translator. Гейт = pipeline:create.
     * @param {V1CreatePipelineStageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceCreatePipelineStage(
      body: V1CreatePipelineStageRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PipelineStageResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceCreatePipelineStage(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceCreatePipelineStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateStageTask — добавить шаблон задачи (title автопереводится). Гейт = pipeline:update.
     * @param {string} stageId
     * @param {PipelineServiceCreateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceCreateStageTask(
      stageId: string,
      body: PipelineServiceCreateStageTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1StageTaskTemplateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceCreateStageTask(
        stageId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceCreateStageTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeletePipelineStage — удалить этап (soft-delete). Запрещено при активных сделках, если не задан reassign_to_stage_id; системные этапы не удаляются. Гейт = pipeline:delete.
     * @param {string} id
     * @param {string} [reassignToStageId] Перенести сделки удаляемого этапа на этот этап (опционально). Без него удаление этапа с активными сделками запрещено.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceDeletePipelineStage(
      id: string,
      reassignToStageId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceDeletePipelineStage(
        id,
        reassignToStageId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceDeletePipelineStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteStageTask — удалить шаблон задачи (soft-delete). Гейт = pipeline:update.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceDeleteStageTask(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceDeleteStageTask(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceDeleteStageTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetPipelineConstructor — конфигурация воронки со ВСЕМИ локалями имён/заголовков (для экрана конструктора). Гейт = pipeline:update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceGetPipelineConstructor(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetPipelineConstructorResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.pipelineServiceGetPipelineConstructor(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceGetPipelineConstructor']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListPipelineStages — этапы воронки с локализованными именами (по user-locale, COALESCE→ru) для канбана и конструктора. Гейт = pipeline:read (ADMIN/HOS/CEO/MANAGER/AGENT).
     * @param {boolean} [includeTaskTemplates] Включить шаблоны задач в каждый этап (для конструктора). По умолчанию false (канбан).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceListPipelineStages(
      includeTaskTemplates?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPipelineStagesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceListPipelineStages(
        includeTaskTemplates,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceListPipelineStages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListStageTasks — шаблоны задач этапа с локализованным заголовком (pipeline:read).
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceListStageTasks(
      stageId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListStageTasksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceListStageTasks(
        stageId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceListStageTasks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ReorderPipelineStages — переупорядочить этапы (полный список id в новом порядке). Гейт = pipeline:update.
     * @param {V1ReorderPipelineStagesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceReorderPipelineStages(
      body: V1ReorderPipelineStagesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPipelineStagesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.pipelineServiceReorderPipelineStages(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceReorderPipelineStages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdatePipelineStage — изменить этап (имя/цвет/тип/WIP). Имя — ручной оверрайд локали автора + автоперевод недостающих. Гейт = pipeline:update.
     * @param {string} id
     * @param {PipelineServiceUpdatePipelineStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceUpdatePipelineStage(
      id: string,
      body: PipelineServiceUpdatePipelineStageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PipelineStageResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceUpdatePipelineStage(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceUpdatePipelineStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateStageTask — изменить шаблон задачи. Гейт = pipeline:update.
     * @param {string} id
     * @param {PipelineServiceUpdateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceUpdateStageTask(
      id: string,
      body: PipelineServiceUpdateStageTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1StageTaskTemplateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceUpdateStageTask(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceUpdateStageTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PipelineServiceApi - factory interface
 * @export
 */
export const PipelineServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PipelineServiceApiFp(configuration)
  return {
    /**
     *
     * @summary CreatePipelineStage — создать этап. name вводится в ОДНОМ поле (локаль автора), бэкенд автопереводит на 3 локали через translator. Гейт = pipeline:create.
     * @param {V1CreatePipelineStageRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreatePipelineStage(
      body: V1CreatePipelineStageRequest,
      options?: any,
    ): AxiosPromise<V1PipelineStageResponse> {
      return localVarFp
        .pipelineServiceCreatePipelineStage(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateStageTask — добавить шаблон задачи (title автопереводится). Гейт = pipeline:update.
     * @param {string} stageId
     * @param {PipelineServiceCreateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreateStageTask(
      stageId: string,
      body: PipelineServiceCreateStageTaskBody,
      options?: any,
    ): AxiosPromise<V1StageTaskTemplateResponse> {
      return localVarFp
        .pipelineServiceCreateStageTask(stageId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeletePipelineStage — удалить этап (soft-delete). Запрещено при активных сделках, если не задан reassign_to_stage_id; системные этапы не удаляются. Гейт = pipeline:delete.
     * @param {string} id
     * @param {string} [reassignToStageId] Перенести сделки удаляемого этапа на этот этап (опционально). Без него удаление этапа с активными сделками запрещено.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeletePipelineStage(
      id: string,
      reassignToStageId?: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .pipelineServiceDeletePipelineStage(id, reassignToStageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteStageTask — удалить шаблон задачи (soft-delete). Гейт = pipeline:update.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeleteStageTask(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .pipelineServiceDeleteStageTask(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetPipelineConstructor — конфигурация воронки со ВСЕМИ локалями имён/заголовков (для экрана конструктора). Гейт = pipeline:update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceGetPipelineConstructor(
      options?: any,
    ): AxiosPromise<V1GetPipelineConstructorResponse> {
      return localVarFp
        .pipelineServiceGetPipelineConstructor(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListPipelineStages — этапы воронки с локализованными именами (по user-locale, COALESCE→ru) для канбана и конструктора. Гейт = pipeline:read (ADMIN/HOS/CEO/MANAGER/AGENT).
     * @param {boolean} [includeTaskTemplates] Включить шаблоны задач в каждый этап (для конструктора). По умолчанию false (канбан).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListPipelineStages(
      includeTaskTemplates?: boolean,
      options?: any,
    ): AxiosPromise<V1ListPipelineStagesResponse> {
      return localVarFp
        .pipelineServiceListPipelineStages(includeTaskTemplates, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListStageTasks — шаблоны задач этапа с локализованным заголовком (pipeline:read).
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListStageTasks(
      stageId: string,
      options?: any,
    ): AxiosPromise<V1ListStageTasksResponse> {
      return localVarFp
        .pipelineServiceListStageTasks(stageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ReorderPipelineStages — переупорядочить этапы (полный список id в новом порядке). Гейт = pipeline:update.
     * @param {V1ReorderPipelineStagesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceReorderPipelineStages(
      body: V1ReorderPipelineStagesRequest,
      options?: any,
    ): AxiosPromise<V1ListPipelineStagesResponse> {
      return localVarFp
        .pipelineServiceReorderPipelineStages(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdatePipelineStage — изменить этап (имя/цвет/тип/WIP). Имя — ручной оверрайд локали автора + автоперевод недостающих. Гейт = pipeline:update.
     * @param {string} id
     * @param {PipelineServiceUpdatePipelineStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdatePipelineStage(
      id: string,
      body: PipelineServiceUpdatePipelineStageBody,
      options?: any,
    ): AxiosPromise<V1PipelineStageResponse> {
      return localVarFp
        .pipelineServiceUpdatePipelineStage(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateStageTask — изменить шаблон задачи. Гейт = pipeline:update.
     * @param {string} id
     * @param {PipelineServiceUpdateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdateStageTask(
      id: string,
      body: PipelineServiceUpdateStageTaskBody,
      options?: any,
    ): AxiosPromise<V1StageTaskTemplateResponse> {
      return localVarFp
        .pipelineServiceUpdateStageTask(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PipelineServiceApi - object-oriented interface
 * @export
 * @class PipelineServiceApi
 * @extends {BaseAPI}
 */
export class PipelineServiceApi extends BaseAPI {
  /**
   *
   * @summary CreatePipelineStage — создать этап. name вводится в ОДНОМ поле (локаль автора), бэкенд автопереводит на 3 локали через translator. Гейт = pipeline:create.
   * @param {V1CreatePipelineStageRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceCreatePipelineStage(
    body: V1CreatePipelineStageRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceCreatePipelineStage(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateStageTask — добавить шаблон задачи (title автопереводится). Гейт = pipeline:update.
   * @param {string} stageId
   * @param {PipelineServiceCreateStageTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceCreateStageTask(
    stageId: string,
    body: PipelineServiceCreateStageTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceCreateStageTask(stageId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeletePipelineStage — удалить этап (soft-delete). Запрещено при активных сделках, если не задан reassign_to_stage_id; системные этапы не удаляются. Гейт = pipeline:delete.
   * @param {string} id
   * @param {string} [reassignToStageId] Перенести сделки удаляемого этапа на этот этап (опционально). Без него удаление этапа с активными сделками запрещено.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceDeletePipelineStage(
    id: string,
    reassignToStageId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceDeletePipelineStage(id, reassignToStageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteStageTask — удалить шаблон задачи (soft-delete). Гейт = pipeline:update.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceDeleteStageTask(id: string, options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceDeleteStageTask(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetPipelineConstructor — конфигурация воронки со ВСЕМИ локалями имён/заголовков (для экрана конструктора). Гейт = pipeline:update.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceGetPipelineConstructor(options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceGetPipelineConstructor(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListPipelineStages — этапы воронки с локализованными именами (по user-locale, COALESCE→ru) для канбана и конструктора. Гейт = pipeline:read (ADMIN/HOS/CEO/MANAGER/AGENT).
   * @param {boolean} [includeTaskTemplates] Включить шаблоны задач в каждый этап (для конструктора). По умолчанию false (канбан).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceListPipelineStages(
    includeTaskTemplates?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceListPipelineStages(includeTaskTemplates, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListStageTasks — шаблоны задач этапа с локализованным заголовком (pipeline:read).
   * @param {string} stageId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceListStageTasks(stageId: string, options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceListStageTasks(stageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ReorderPipelineStages — переупорядочить этапы (полный список id в новом порядке). Гейт = pipeline:update.
   * @param {V1ReorderPipelineStagesRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceReorderPipelineStages(
    body: V1ReorderPipelineStagesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceReorderPipelineStages(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdatePipelineStage — изменить этап (имя/цвет/тип/WIP). Имя — ручной оверрайд локали автора + автоперевод недостающих. Гейт = pipeline:update.
   * @param {string} id
   * @param {PipelineServiceUpdatePipelineStageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceUpdatePipelineStage(
    id: string,
    body: PipelineServiceUpdatePipelineStageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceUpdatePipelineStage(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateStageTask — изменить шаблон задачи. Гейт = pipeline:update.
   * @param {string} id
   * @param {PipelineServiceUpdateStageTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceUpdateStageTask(
    id: string,
    body: PipelineServiceUpdateStageTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceUpdateStageTask(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
